import React from 'react';
import {connect} from 'react-redux'
import {compose, lifecycle} from 'recompose';
import {getUser} from './store/actions/user';
import './App.css';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {HashRouter, Route, Switch} from 'react-router-dom'
import {LoomisColors} from './lib/LoomisColors';

// Pages
import MainPage from './pages/MainPage';
import LoginPage from './pages/LoginPage';
import ForgotPage from './pages/ForgotPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

import Logout from './components/logout/Logout';


import CustomersPage from './pages/CustomersPage';
import CustomerPage from './pages/CustomerPage';
import BranchPage from './pages/BranchPage';
import StatusPage from './pages/StatusPage';
import CustomerMapPage from './pages/CustomerMapPage';
import BranchMapPage from './pages/BranchMapPage';
import OperatorPage from './pages/OperatorPage';
import OperatorsPage from './pages/OperatorsPage';
import ProfilePage from './pages/ProfilePage';
import InviteUserPage from './pages/InviteUserPage';
import TransactionDayPage from './pages/TransactionDayPage';
import ReportPage from "./pages/ReportPage";

const muiTheme = getMuiTheme({
    fontFamily: 'Lato, sans-serif',
    palette: {
        primary1Color: LoomisColors.darkBlue,
        primary2Color: LoomisColors.red,
        primary3Color: LoomisColors.grey,
        accent1Color: LoomisColors.red,
        // accent2Color: LoomisColors.lighterGrey,
        accent2Color: LoomisColors.lightestGrey,
        accent3Color: LoomisColors.grey,
        textColor: LoomisColors.darkerBlue,
        alternateTextColor: LoomisColors.white,
        canvasColor: LoomisColors.white,
        borderColor: LoomisColors.lightGrey,
        // disabledColor: fade(darkBlack, 0.3),
        // pickerHeaderColor: cyan500,
        // clockCircleColor: fade(darkBlack, 0.07),
        shadowColor: LoomisColors.black,
    },
    textField: {
        textColor: LoomisColors.darkBlue,
        floatingLabelColor: LoomisColors.darkBlue,
    },
});

const App = (props) => {
    return (
        <HashRouter>
            <MuiThemeProvider muiTheme={muiTheme}>
                <Switch>
                    <Route exact path="/" component={MainPage}/>
                    <Route path="/login" component={LoginPage}/>
                    <Route path="/logout" component={Logout}/>
                    <Route path="/forgot" component={ForgotPage}/>
                    <Route path="/reset/:token" component={ResetPasswordPage}/>
                    <Route path="/invite/:token" component={InviteUserPage}/>

                    <Route path="/profile" component={ProfilePage}/>
                    <Route path="/customers/:customerId/status" component={StatusPage}/>
                    <Route path="/customers/:customerId/map" component={CustomerMapPage}/>
                    <Route path="/customers/:customerId/:branchId/operators/new" component={OperatorPage}/>
                    <Route path="/customers/:customerId/:branchId/operators/:operatorId" component={OperatorPage}/>
                    <Route path="/customers/:customerId/:branchId/operators" component={OperatorsPage}/>
                    <Route path="/customers/:customerId/:branchId/map" component={BranchMapPage}/>
                    <Route path="/customers/:customerId/:branchId/transactions/:transactionDay" component={TransactionDayPage}/>
                    <Route path="/customers/:customerId/:branchId" component={BranchPage}/>
                    <Route path="/customers/:customerId" component={CustomerPage}/>
                    <Route path="/customers" component={CustomersPage}/>
                    <Route path="/report" component={ReportPage}/>

                    <Route component={MainPage}/>
                </Switch>
            </MuiThemeProvider>
        </HashRouter>
    )
};


const mapDispatchToProps = (dispatch) => {
    return {
        getUser: () => dispatch(getUser())
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.getUser();
    }
};

export default compose(
    connect(null, mapDispatchToProps),
    lifecycle(lifecycleValue)
)(App);




// WEBPACK FOOTER //
// ./src/App.js